import React from 'react';
import ReactPlayer from 'react-player';
import DateFormatter from './formatDate';
import { message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';

class OtherBayansContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
  }
  onCopy = () => {
    message.success('Link copied to clip board');
  };
  render() {
    const { bayansCount, bayans } = this.props;
    return (
      <div className='row'>
        {bayansCount > 0
          ? bayans.map((key, count) => {
              return count === 0 ? (
                ''
              ) : (
                <div className='col-lg-6 col-md-12' key={key.id}>
                  <div className='fea-video other-video'>
                    <div className='iframe-video'>
                      <div className='video-wraper player-wrapper'>
                        <ReactPlayer
                          className='react-player'
                          url={key.videoURL}
                          playing={false}
                          controls={true}
                          width='100%'
                          height='100%'
                        />
                      </div>
                    </div>
                    <div className='video-info'>
                      <h2>{key.title}</h2>
                      <p>By: {key.name}</p>
                      <div className='video-info-small'>
                        <p>
                          <img src='images/clock-icon.png' alt='' />{' '}
                          <DateFormatter custom={'true'} date={key.date} />
                        </p>
                        &nbsp;
                        <p>
                          <img src='images/folder-icon.png' alt='' />{' '}
                          {key.category}
                        </p>
                        &nbsp;
                        <CopyToClipboard
                          text={key.videoURL}
                          onCopy={this.onCopy}
                        >
                          <p style={{ cursor: 'pointer' }}>
                            <img
                              src='images/share-icon.png'
                              onClick={this.handClick}
                              alt=''
                            />
                            Share
                          </p>
                        </CopyToClipboard>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          : ''}
      </div>
    );
  }
}

export default OtherBayansContent;
